import React, { useRef } from 'react'
import { IconButton } from '../../../ui'

const SESSION_COLOR = '#9b6cc4'

export function QuickList({ items = [], onChange, maxItems = 10, maxChars = 140, readOnly = false, addLabel = 'add' }) {
  const inputRefs = useRef([])

  const displayItems = items.length === 0 ? [''] : items

  function handleChange(index, val) {
    const next = [...items]
    next[index] = val
    onChange({ items: next })
  }

  function handleKeyDown(e, index) {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (items.length < maxItems) {
        const next = [...items]
        next.splice(index + 1, 0, '')
        onChange({ items: next })
        setTimeout(() => inputRefs.current[index + 1]?.focus(), 0)
      }
    } else if (e.key === 'Backspace' && items[index] === '' && items.length > 1) {
      e.preventDefault()
      const next = items.filter((_, i) => i !== index)
      onChange({ items: next })
      setTimeout(() => inputRefs.current[Math.max(0, index - 1)]?.focus(), 0)
    }
  }

  function handleBlur(index) {
    if (items[index] === '' && index < items.length - 1) {
      onChange({ items: items.filter((_, i) => i !== index) })
    }
  }

  function handleAdd() {
    if (items.length < maxItems) {
      onChange({ items: [...items, ''] })
      setTimeout(() => inputRefs.current[items.length]?.focus(), 0)
    }
  }

  function handleRemove(index) {
    if (items.length <= 1) {
      onChange({ items: [''] })
    } else {
      onChange({ items: items.filter((_, i) => i !== index) })
    }
  }

  return (
    <div style={styles.wrap}>
      {displayItems.map((item, index) => (
        <div key={index} style={styles.row}>
          <span style={styles.prefix}>–</span>
          <input
            ref={(el) => { inputRefs.current[index] = el }}
            style={styles.input}
            value={item}
            maxLength={maxChars}
            disabled={readOnly}
            placeholder={readOnly ? '' : 'Add item…'}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onBlur={() => handleBlur(index)}
            aria-label={`Item ${index + 1}`}
          />
          {!readOnly && items.length > 0 && (
            <IconButton ariaLabel="Remove item" onClick={() => handleRemove(index)} tabIndex={-1}>×</IconButton>
          )}
        </div>
      ))}
      {!readOnly && displayItems.length < maxItems && (
        <button style={styles.addBtn} onClick={handleAdd}>+ {addLabel}</button>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 12px 12px', display: 'flex', flexDirection: 'column', gap: '4px' },
  row: { display: 'flex', alignItems: 'center', gap: '6px' },
  prefix: { fontSize: '12px', color: 'var(--text-secondary)', opacity: 0.5, minWidth: '10px', flexShrink: 0 },
  input: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '12px', color: 'var(--text-primary)', lineHeight: '1.5', padding: '2px 0',
  },
  addBtn: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px',
    color: SESSION_COLOR, padding: '2px 0', marginLeft: '16px', marginTop: '2px', textAlign: 'left',
  },
}
